<form [formGroup]="formGroup" [bitSubmit]="beginMechanismSetup">
  <p class="tw-mb-4">为您的个人密码库设置秘密机关。无需提供邮箱或手机号。</p>
  <p class="tw-mb-4">设置只进行一次。请独自操作，私人摆法和恢复文件不要发到聊天里。</p>
  <button type="submit" bitButton bitFormButton block buttonType="primary">开始设置机关</button>
</form>
